import { Auction } from "features/auction/types";

export enum MERCHANT_REQUEST_STATUS {
  WAIT_LIST = "pending",
  PROCESSING = "processing",
  COMPLETED = "completed",
  REMOVED = "removed",
}

export interface MerchantResponse {
  id: number,
  fullName: string,
  phoneNumber: string,
}

export interface MerchantRequest {
  id: string;
  merchant: MerchantResponse;
  staff: MerchantResponse;
  type: string;
  status: string;
  createdAt: string;
  updateAt?: string;
  merchantNote: string;
  staffNote?: string | null;
  carNote?: string | null;
  name: string;
  minPrice?: number;
  maxPrice?: number;
  totalCars?: number;
  service?: {
    id: number;
    name: string;
    kindOf?:"request_auction"
  }
  carAuction?: {
    [key: string]: Auction
  },
  startDate?: string,
  endDate?: string,
  carIds?: number[]
}

export interface MerchantRequestQueryParams {
  skip: number,
  take: number,
  id?: string | null,
  status?: string | null,
  type?: string | null,
  merchant?: number | string | null,
  merchantName?: string,
  startDate?: string | null,
  endDate?: string | null
  language: string,
} 